module.exports = function _pipeP(f, g) {
  return function() {
    var ctx = this;
    return f.apply(ctx, arguments).then(function(x) {
      return g.call(ctx, x);
    });
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_pipeP.js
// module id = 384
// module chunks = 35783957827783 114276838955818